var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "archives" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.offlineSupportRequests") }],
            select: true,
          },
        },
        [
          _vm.tabIndex === 1
            ? _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeSelect,
                      expression: "timeSelect",
                    },
                  ],
                  attrs: { id: "time-select" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.timeSelect = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "today" } }, [
                    _vm._v(_vm._s(_vm.$t("time.today"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "yesterday" } }, [
                    _vm._v(_vm._s(_vm.$t("time.yesterday"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-week" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("time.currentWeek")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-week" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-month" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("time.currentMonth")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-month" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastMonth"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-30" } }, [
                    _vm._v(_vm._s(_vm.$t("time.last30Day"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "all-time" } }, [
                    _vm._v(_vm._s(_vm.$t("time.allTime"))),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "position-relative pt-3",
          staticStyle: { padding: "0 30px" },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { span: "12" },
                  on: {
                    change: function ($event) {
                      return _vm.updateQueryParams()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "menu-button-base",
                          class: {
                            "menu-button": _vm.tabIndex !== 0,
                            "selected-link": _vm.tabIndex === 0,
                          },
                          on: {
                            click: function ($event) {
                              _vm.tabIndex = 0
                            },
                          },
                        },
                        [
                          _c("OfflineSupWaiting", {
                            staticStyle: {
                              "margin-bottom": "-1px",
                              width: "1.25em",
                              "margin-right": "1em",
                            },
                            attrs: {
                              fill: _vm.tabIndex === 0 ? "#03a9f4" : "#808184",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "4px" } },
                            [_vm._v(_vm._s(_vm.$t("message.waitingReply")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "menu-button-base",
                          class: {
                            "menu-button": _vm.tabIndex !== 1,
                            "selected-link": _vm.tabIndex === 1,
                          },
                          on: {
                            click: function ($event) {
                              _vm.tabIndex = 1
                            },
                          },
                        },
                        [
                          _c("ArchiveIcon", {
                            staticStyle: {
                              "margin-bottom": "-1px",
                              width: "1.25em",
                              "margin-right": "1em",
                            },
                            attrs: {
                              fill: _vm.tabIndex === 1 ? "#03a9f4" : "#808184",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "4px" } },
                            [_vm._v(_vm._s(_vm.$t("message.archive")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _vm.tabIndex === 0
                    ? _c("AwaitReply", {
                        staticStyle: { "padding-left": "0 !important" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabIndex === 1
                    ? _c("OfflineRequestArchives", {
                        attrs: { "time-select": _vm.timeSelect },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }